import { useRequest } from 'ahooks'
import { SupportedTicker, TICKERS, TICKERS_MAP_BY_NAME } from '@/constants/token'

export const getTokenUsdPrice = async (ids: string | string[], vsCurrencies = 'usd') => {
  const resp = await fetch(
    `https://api.coingecko.com/api/v3/simple/price?ids=${
      ids instanceof Array ? ids.join(',') : ids
    }&vs_currencies=${vsCurrencies}`,
    {
      method: 'GET',
    },
  )

  const respJson: Record<string, { usd: number }> = await resp.json()

  return ids instanceof Array ? respJson : respJson?.[ids]?.[vsCurrencies]
}

export const useUsdPriceOfToken = (ids?: string | string[], options?: { pollingInterval?: number }) => {
  return useRequest(
    async (_ids?: string | string[]) => {
      return getTokenUsdPrice(ids ?? _ids)
    },
    {
      ready: !!ids,
      cacheKey: ids ? `Usd_Price_Of_${ids.toString()}` : undefined,
      pollingInterval: options?.pollingInterval,
      pollingWhenHidden: false,
    },
  )
}

export const useUsdPriceOfAllTokens = (options?: { pollingInterval?: number }) => {
  return useUsdPriceOfToken(
    TICKERS.filter((ticker) => !!ticker?.coinGeckoId).map((ticker) => ticker.coinGeckoId),
    options,
  )
}

export const useUsdPriceOfOneToken = (tickerName: SupportedTicker, options?: { pollingInterval?: number }) => {
  const requestData = useUsdPriceOfAllTokens(options)
  return { ...requestData, data: requestData?.data[TICKERS_MAP_BY_NAME[tickerName]?.coinGeckoId]?.usd }
}

interface CoinMarketCapPriceResponse {
  data: Record<
    number,
    {
      quote: {
        USD: {
          price: number
        }
      }
    }
  >
}

export enum CoinMarketCapTokenIdMap {
  'multibit' = 28412,
}

export const fetchPriceFromCoinMarketCap = async ({
  ids,
  convert = 'USD',
}: {
  ids: (number | string)[]
  convert?: string
}): Promise<CoinMarketCapPriceResponse> => {
  return fetch(`https://api.multibit.exchange/vendor/api/quotes/latest?id=${ids.join(',')}&convert=${convert}`).then(
    (res) => res.json(),
  )
}
